<template>
	<span class="is-sr-only">({{ $t( 'opens_in_new_tab' ) }})</span>
	<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M4 2.5H0.5V9.5H7.5V6" stroke="currentcolor"></path>
		<path d="M3.5 6.5L9 1" stroke="currentcolor"></path>
		<path d="M5 0.5H9.5V5" stroke="currentcolor"></path>
	</svg>
</template>
